var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tinymce-editor',{attrs:{"api-key":"no-api-key","disabled":_vm.disabled,"plugins":"code table charmap autolink link lists media visualblocks image imagetools paste fullscreen autoresize","toolbar":"forecolor backcolor bold italic | numlist bullist media | alignleft aligncenter alignright outdent\n        indent | code charmap visualblocks | link image embedgooglemap fileattach | fullscreen","init":{
        skin_url: '/js/tinymce/skins/ui/oxide',
        content_css: '/css/tinymce.css',
        imagetools_toolbar: 'imageoptions',
        contextmenu: "link image inserttable | cell row column deletetable",
        branding: false,
        language: this.locale,
        br_in_pre: false,
        menubar: false,
        paste_data_images: false,
        automatic_uploads: false,
        image_title: true,
        file_picker_types: false,
        relative_urls : false,
        remove_script_host : true,
        min_height: 100,
        mobile: false,
        statusbar: false,
        autoresize: true,
   }},model:{value:(_vm.question.text),callback:function ($$v) {_vm.$set(_vm.question, "text", $$v)},expression:"question.text"}})}
var staticRenderFns = []

export { render, staticRenderFns }